import { useState, useEffect } from "react";
import {
  HeaderComponent,
  BodyComponent,
  TableComponent,
  ActionComponent,
  CreateButton,
  RefreshButton,
  trans
} from "@comps/components";
import { makeRequest, removeById } from "@utils/helpers";
import { getAllServers, deleteDataReq } from "./requests";
import { seedTenants } from "../tenants/requests";
import { makeRequestStateless } from "@utils/helpers";
import { Commons, Const } from "../constants";
import { Checkbox, message } from 'antd';
import CreateTenant from "./components/CreateServer";
import UpdateTenant from "./components/UpdateServer";
import { useSelector } from "react-redux";


// ==================================
//   Page Breadcrumbs Start
// ==================================

const langKey = Const["servers"].lngKey;

const pageConfig = {
  headers: {
    title: trans(`${langKey}.moduleName`),
    breadcrumb: [
      {
        name: trans(`${langKey}.moduleName`),
        path: Const["tenants"].route
      }
    ]
  }
}

let serverName = ""

// ==================================
//   Page Breadcrumbs End
// ==================================

const IndexServers = (props) => {

  const authUser = useSelector((state) => state.auth.authUser);
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);
  const [related, setRelated] = useState([]);


  // ==================================
  //   Use States End
  // ==================================

  // ==================================
  //   Table Data End
  // ==================================

  const onChange = (checked, item) => {
    // updateStatus(checked, item.uuid)
    //   .then(res => {
    //     const obj = tenants.find(val => val.uuid === res.uuid)
    //     if (obj !== undefined) {
    //       obj.active = res.active
    //     }
    //   })
    //   .catch(err => console.error(err))
  }

  const columns = [
    {
      key: trans(`${langKey}.name`),
      title: trans(`${langKey}.name`),
      dataIndex: "name"
    },
    {
      key: trans(`${langKey}.domain`),
      title: trans(`${langKey}.domain`),
      dataIndex: "domain"
    },
    {
      key: trans(`${langKey}.ip`),
      title: trans(`${langKey}.ip`),
      dataIndex: "ip"
    },
    {
      key: trans(`${langKey}.noOfSaas`),
      title: trans(`${langKey}.noOfSaas`),
      dataIndex: "noOfSaas"
    },
    {
      key: trans(`${langKey}.isActive`),
      title: trans(`${langKey}.isActive`),
      dataIndex: "active",
      render: (val, item) => {
        return (
          <Checkbox defaultChecked={ val } onChange={ (e) => onChange(e.target.checked, item) } />
        )
      }
    },
    {
      key: trans(Commons.actions),
      title: trans(Commons.actions),
      render: (record) => (

        <ActionComponent
          each={ record }
          //onDelete={ onDelete }
          onEdit={ onEdit }
          onSeed={ process.env.REACT_APP_SEEDER && process.env.REACT_APP_SEEDER === authUser && onSeed }
        ></ActionComponent>
      ),
    },
  ];

  // ==================================
  //   Table Data End
  // ==================================

  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, []);

  //event
  useEffect(() => {
    getAllData();
  }, []);

  //end event

  const getAllData = () => {
    makeRequest(setLoader, getAllServers, null, onSuccess, onError);
  };

  const onSuccess = (response) => {
    setDataSource(response)
    setRelated(response)
  };

  const onError = (err, res) => {
    message.error(err);
  }

  const onCreate = () => {
    setChildComponent(<CreateTenant related={ related } onCompleted={ onCompleted } onSuccess={ onSuccess } />);
  };

  const onEdit = (record) => {
    setChildComponent(
      <UpdateTenant onCompleted={ onCompleted } record={ record } disabled={ false } related={ related } />
    );
  };

  const onSeed = (record) => {
    if (record.uuid) {
      serverName = record.name;
      makeRequestStateless(seedTenants, record.uuid, onSeedSuccess, onSeedError);
    }
  };

  const onSeedSuccess = (res) => {
    message.success(`Seeding for ${serverName} is successful`);
  };

  const onSeedError = (err) => {
    message.error(`Seeding for ${serverName} is failed`);
  };

  const onView = (record) => {
    setChildComponent(
      <UpdateTenant onCompleted={ onCompleted } record={ record } disabled={ true } related={ related } />
    );
  };

  const onDelete = (record) => {
    makeRequest(setLoader, deleteDataReq, record.id, onDeleted, onError);
  };
  const onDeleted = (res) => {
    onSuccess(res)
    // getAllData();
    setDataSource(removeById(dataSource, res.id));
    message.success("Deleted")
  };

  const onCompleted = (data) => {
    if (data) {
      getAllData()
    }
    setChildComponent(null);
  };


  //----end filter--------------------
  return (
    <>

      { childComponent }

      <HeaderComponent headers={ pageConfig.headers } >
        <RefreshButton onClick={ getAllData } />
        <CreateButton onClick={ onCreate } />
      </HeaderComponent>

      <BodyComponent>
        <TableComponent
          loader={ loader }
          columns={ columns }
          dataSource={ dataSource }
          pagination={ true }
        />

      </BodyComponent>

    </>
  );
};

export default IndexServers;

